module.exports = __webpack_public_path__ + "img/rxcard_logo_sm.8b93c6ad.png";